import React from 'react';
import { SvgIcon, SvgIconProps } from '@material-ui/core';
import mainColors from '../../../../themes/main-colors';

interface CustomIconProps extends Omit<SvgIconProps, 'color'> {
  color?: string;
  size?: number;
  bgColor?: string;
}

const ServiceLocationIcon: React.FC<CustomIconProps> = ({
  color = mainColors.wizardBlue,
  size = 44,
  ...props
}) => {
  const shadow = 'drop-shadow(0px 0px 5px rgba(0,0,0,0.5))';

  return (
    <svg
      {...props}
      width={size}
      height={size}
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ filter: shadow }}
    >
      <g>
        <rect x="6" y="6" width="48" height="48" rx="24" fill={color} />
        <rect
          x="7"
          y="7"
          width="46"
          height="46"
          rx="23"
          stroke="white"
          strokeWidth="2"
        />
        <mask
          id="mask0"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="17"
          y="17"
          width="26"
          height="26"
        >
          <rect x="17" y="17" width="26" height="26" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0)">
          <path
            d="M21.875 39.2812V28.7334L19.6106 30.4667L18.875 29.4895L21.875 27.2021V24.2917H23.1043V26.2479L30 21L41.125 29.5063L40.3895 30.4667L38.125 28.7334V39.2812H31.0939V33.3021H28.9061V39.2812H21.875Z"
            fill="white"
          />
        </g>
      </g>
    </svg>
  );
};

export default ServiceLocationIcon;
